module.exports = __webpack_public_path__ + "static/media/1.2.81eb1555.zip";